import { SBALoanDraws } from './SBALoanDraws';
import { SBA_LOAN_CONFIG } from './loan-configs';

/**
 * SBA loan ledger. Renders the draw-period tracker (bucket budgets,
 * recorded draws, closing disclosure) — standard amortization doesn't
 * begin until the draw window closes. Terms live in `loan-configs.ts`
 * so the Debt Balances rollup and this page always agree.
 */
export function SBALoanPage() {
  return (
    <SBALoanDraws
      config={SBA_LOAN_CONFIG}
    />
  );
}
